module.exports = __webpack_public_path__ + "static/img/shuiya2.5bb5bd48.png";